import { MenuAndContent } from 'app/components/layouts';
import { HideMyEmailPage } from 'app/pages/Faq';
import { MaintenanceSchedules } from 'app/pages/MaintenanceSchedulePage';
import { MaintenanceDetails } from 'app/pages/MaintenanceSchedulePage/Details';
import { ResourcesPage } from 'app/pages/ResourcesPage';
import { GuidesPage } from 'app/pages/ResourcesPage/GuidesPage';
import { ManualViewer } from 'app/pages/ResourcesPage/ManualViewer';
import { ModelPage } from 'app/pages/ResourcesPage/ModelPage';
import { ResourceSubcategoriesPage } from 'app/pages/ResourcesPage/ResourceSubcategoriesPage';
import { ResourcesFaultCodesPage } from 'app/pages/ResourcesPage/ResourcesFaultCodesPage';
import { VideoResourcesPage } from 'app/pages/ResourcesPage/VideoResourcesPage';
import React from 'react';
import { Route } from 'react-router-dom';

export default function SharedRoutes() {
  return (
    <>
      <Route
        path="/resources"
        element={
          <MenuAndContent>
            <ResourcesPage />
          </MenuAndContent>
        }
      />

      <Route
        path="/resources/:id/"
        element={
          <MenuAndContent>
            <ResourceSubcategoriesPage />
          </MenuAndContent>
        }
      />

      <Route
        path="/models/:model/"
        element={
          <MenuAndContent>
            <ModelPage />
          </MenuAndContent>
        }
      />

      <Route
        path="/models/:model/maintenanceSchedule"
        element={
          <MenuAndContent>
            <MaintenanceSchedules />
          </MenuAndContent>
        }
      />

      <Route
        path="/models/:model/maintenanceSchedule/:interval"
        element={
          <MenuAndContent>
            <MaintenanceDetails />
          </MenuAndContent>
        }
      />

      <Route
        path="/faultCodes/:model/"
        element={
          <MenuAndContent>
            <ResourcesFaultCodesPage />
          </MenuAndContent>
        }
      />

      <Route
        path="/manual/:model/"
        element={
          <MenuAndContent>
            <ManualViewer />
          </MenuAndContent>
        }
      />

      <Route
        path="/videoResources/:model/"
        element={
          <MenuAndContent>
            <VideoResourcesPage />
          </MenuAndContent>
        }
      />

      <Route
        path="/guides/:model/"
        element={
          <MenuAndContent>
            <GuidesPage />
          </MenuAndContent>
        }
      />

      <Route
        path="/faq/hidemyemail"
        element={
          <MenuAndContent>
            <HideMyEmailPage />
          </MenuAndContent>
        }
      />
    </>
  );
}
